import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePrevious } from './index';

export default function useHandleRouteWhenAuth() {
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthenticated = useSelector((store) => store.auth.isAuthenticated);
  const isPrevAuthenticated = usePrevious(isAuthenticated);

  useEffect(() => {
    // Login sayfasında değilsek ve authentication durumu değiştiyse
    if (!isPrevAuthenticated && isAuthenticated && location.pathname !== '/login') {
      const nextRoute =
        (location.state && location.state.from) || location.pathname || "/home";
      navigate(nextRoute, { replace: true });
    }
    return () => {};
  }, [isAuthenticated, isPrevAuthenticated, location, navigate]);
}
